import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useCopyToClipboard } from '@/hooks/_legacy/useCopy/useCopyToClipboard'

import { ActionMenuSnackbarItem } from '../ActionMenuSnackbarItem/ActionMenuSnackbarItem'
import { MenuItemLike, WithSnackbarMessages } from '../index.types'

type Props<Data extends Record<string, unknown>> = MenuItemLike & {
  getValueToCopy: (row: Data) => Promise<string> | string
  icon?: React.ReactElement
} & WithSnackbarMessages<Data>

/** Component to be used as a base for creating new ActionCopyItems if messages need to be overwritten. NOT for standalone use (eg. ActionCopyTokenItem) */
export const ActionCopyItem = <Data extends Record<string, unknown>>({
  displaySeparately,
  errorMessage = 'Failed to copy',
  successMessage = 'Copied to clipboard',
  getValueToCopy,
  overrideText,
  icon = <ContentCopyIcon />
}: Props<Data>) => {
  const { copyToClipboard } = useCopyToClipboard()

  const handleCopy = async (row: Data) => {
    try {
      const result = await getValueToCopy(row)
      const valueToCopy = typeof result === 'string' ? result : String(row.id)
      await copyToClipboard(valueToCopy, { suppressSnackbar: true })
    } catch (e) {
      throw new Error('Failed to copy')
    }
  }

  return (
    <ActionMenuSnackbarItem
      displaySeparately={displaySeparately}
      errorMessage={errorMessage}
      successMessage={successMessage}
      onClick={handleCopy}
      overrideText={overrideText}
      icon={icon}
      text="Copy to Clipboard"
    />
  )
}
